import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Personal_Report_Filter from "./personal_report_filter/Personal_Report_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Personal_Report_Table from "./personal_report_table/Personal_Report_Table";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCustomerReport,
  GetPersnalDetailReport,
} from "../../../../../../../features/admin/report_generator/Slice";
import { GETAuthLogin } from "../../../../../../../features/auth/Slice";
import { GetAll } from "../../../../../../../../src/features/admin/quality_management/resource_requirement/personal_detail/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Personal_Report = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const personaldetails = useSelector((state) => state.personnel_details);

  const [searchParams, setSearchParams] = useState({
    specialization_id: "",
    designation_id: "",
    end_date: "",
    start_date: "",
  });
  const authdetails = useSelector((state) => state.auth);

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.personnel_report.Report);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: personaldetails.per_page,
        specialization_id: searchParams?.specialization_id?.value,
        designation_id: searchParams?.designation_id?.value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [dispatch, currentPage, searchParams]);
  useEffect(() => {
    dispatch(GETAuthLogin());
  }, [dispatch]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetPersnalDetailReport({
        page: 1,
        per_page: personaldetails.per_page,
        specialization_id: searchParams?.specialization_id?.value,
        designation_id: searchParams?.designation_id?.value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Personal_Report_Filter
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setShow={setShow}
          reportgenerate={reportgenerate}
          fetchCustomers={fetchCustomers}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Personal_Report_Table
          data={personaldetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Personal Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Personal_Report;
